import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { BuildInfoStore } from '@core/build/build-info.store';

@Injectable()
export class BuildIdTranslateLoader implements TranslateLoader {
    private http = inject(HttpClient);
    private buildInfoStore = inject(BuildInfoStore);

    getTranslation(lang: string): Observable<TranslationObject> {
        const buildId = this.buildInfoStore.snapshot.buildId;
        const cacheBustingQuery = buildId ? `?v=${encodeURIComponent(buildId)}` : '';

        return this.http.get<TranslationObject>(`assets/i18n/${lang}.json${cacheBustingQuery}`);
    }
}
